// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Button } from "@revvsales/components";

// Components Imports
import StatusDropdown from "../QuotationTopbar/StatusDropdown";
import AddRecipientsSection from "./AddRecipientsSection";
// import RecipientListSection from "./RecipientListSection";

// Action Imports

class DocRecipientsPopp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rolesOptions: [
        { value: "Signer", label: this._getLabelIcon("Signer") },
        { value: "Reviewer", label: this._getLabelIcon("Reviewer") },
      ],
      // sharedUsers:
      //   props.recipients && props.recipients.length > 0 && !props.showEdit
      //     ? props.recipients
      //     : [
      //         {
      //           user_email: "",
      //           first_name: "",
      //           last_name: "",
      //           role: "",
      //           id: 0,
      //           disabled: false,
      //         },
      //       ],
      showLoader: false,
      showShareBtnLoader: false,
    };
  }

  _getLabelIcon = value => (
    <span className="documentrecipientlist-role">
      <FontAwesomeIcon
        icon={["far", `${value === "Reviewer" ? "eye" : "signature"}`]}
        className="documentrecipientlist-role-icon"
      />
      <span className="role-icon-mar">{value}</span>
    </span>
  );

  render() {
    const { showEdit, onClose } = this.props;
    const { rolesOptions } = this.state;
    const { showLoader } = this.state;
    return (
      <Modal open onClose={onClose} closeOnOverlayClick={false} center>
        {showLoader && <Loader className="saving-document" />}
        <div className="docrecipientspopup-container">
          <div
            className="quotationtopbar-modal-heading"
            data-test="docrecipientspopup-modal-heading">
            {showEdit ? "Modify Recipients" : "Send Document"}
          </div>

          {/* ----------- Add Recipients Section ----------- */}
          <div className="docrecipientspopup-addrecipients-wrapper">
            <AddRecipientsSection rolesOptions={rolesOptions} />
          </div>

          {/* ----------- Invites Recipient List Section ----------- */}
          {/* <div className="docrecipientspopup-recipientlist-wrapper">
            <RecipientListSection
              recipientList={this.props.recipients}
              rolesOptions={rolesOptions}
            />
          </div> */}

          {/* ----------- Update Document Status Section ----------- */}
          {showEdit && (
            <div className="docrecipientspopup-docstatus-wrapper">
              <div className="doc-status-lable">
                <span>Also update document status to</span>
              </div>
              <div className="doc-status-select">
                <StatusDropdown
                  currentStatus={this.props.docStatus}
                  docId={this.props.docID}
                  source="Popup"
                />
              </div>
            </div>
          )}

          <section className="createquotepopup-footer popup-footer clearfix">
            <div className="footer-actions">
              <Button
                isLoading={this.state.showShareBtnLoader}
                className="btn btn-primary"
                // disabled={this.updateButtonStatus(this.state.sharedUsers)}
                data-test="docrecipientspopup-changes-docstatus-btn"
                id="docrecipientspopup-changes-docstatus-btn"
                onClick={this.props.onClose}>
                {showEdit ? "Done" : "Share document"}
              </Button>
            </div>
          </section>
        </div>
      </Modal>
    );
  }
}

export default DocRecipientsPopp;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocRecipientsPopup.js